export const correlationHeaderName = 'x-correlation-id';
